<template>
  <AuthVisualShell :character-src="characterSrc" character-alt="Personagem Zinnes">
    <div class="login-content">
      <h2>LOGIN</h2>
      <p>Bem-vinda(o) de volta! Acesse sua conta para continuar aproveitando nossos serviços e explorar novas
        oportunidades.</p>

      <v-form @submit.prevent="loginUser" ref="form">
        <v-text-field v-model="email" label="Email" :rules="emailRules" required></v-text-field>
        <v-text-field
          v-model="password"
          label="Senha"
          :type="showPassword ? 'text' : 'password'"
          :rules="passwordRules"
          required
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="togglePasswordVisibility"
        ></v-text-field>
        <p>
          Esqueceu a senha?
          <router-link to="/forgot-password" style="text-decoration: none;">Recuperar</router-link>
        </p>
        <v-btn :loading="isLoading" :disabled="isLoading" color="orange" class="btn-login" type="submit">
          <template v-if="!isLoading">ENTRAR</template>
          <template v-else>Carregando...</template>
        </v-btn>
        <div v-if="errorMessage" class="auth-error">{{ errorMessage }}</div>
      </v-form>

      <p>
        Não tem conta?
        <router-link to="/cadastro" style="text-decoration: none;">Criar conta</router-link>
      </p>
    </div>
  </AuthVisualShell>
</template>

<script>
import AuthVisualShell from '@/components/AuthVisualShell.vue';
import { login } from '../server/authServe';
import { emailRules, passwordRules } from '@/utils/validationUtils';

export default {
  name: 'LoginPage',
  components: {
    AuthVisualShell,
  },
  data() {
    return {
      email: '',
      password: '',
      errorMessage: null,
      showPassword: false,
      isLoading: false,
      emailRules,
      passwordRules,
      characterSrc: require('@/assets/images/Miry.png'),
    };
  },
  methods: {
    async loginUser() {
      const isValid = this.$refs.form.validate();

      if (!isValid) {
        this.errorMessage = 'Por favor, corrija os erros no formulário.';
        return;
      }

      this.isLoading = true;

      try {
        await login(this.email, this.password);
        this.$router.push('/');
      } catch (error) {
        this.errorMessage = error.message || 'Erro ao fazer login';
        console.error('Erro ao fazer login:', this.errorMessage);
      } finally {
        this.isLoading = false;
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  }
}
</script>

<style scoped>
.auth-error {
  color: red;
  margin-bottom: 12px;
}
</style>
